// extracted by mini-css-extract-plugin
module.exports = {"uploadFileWrap":"Images_uploadFileWrap__2os6h","uploadFileLabel":"Images_uploadFileLabel__Cytby","center":"Images_center__iDPRn"};